
import Vue from  'vue';


export default {

    /*props: {
        isMenuOpen : { type : Boolean, default : false }
    },

    watch: {

        isMenuOpen : '_display'
    },

    created()
    {
        // this.randomRoot = this.randomString(4);
    },*/

    /*mounted()
    {
        this._openElmt = this.$el.querySelector('.c-button-menu--open')
        this._closeElmt = this.$el.querySelector('.c-button-menu--close')
        this._display( this.isMenuOpen )
    },*/
}
